import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const applyResponsiveTableLabels = () => {
  const tables = document.querySelectorAll('table');

  tables.forEach(table => {
    const headers = Array.from(table.querySelectorAll('thead th')).map(header =>
      header.textContent.replace(/\s+/g, ' ').trim()
    );

    if (!headers.length) {
      return;
    }

    table.classList.add('responsive-table-ready');

    table.querySelectorAll('tbody tr').forEach(row => {
      Array.from(row.children).forEach((cell, index) => {
        const label = headers[index] || headers[headers.length - 1] || 'Details';
        if (label) {
          cell.setAttribute('data-label', label);
        }
      });
    });
  });
};

const startResponsiveTableObserver = () => {
  let frameId = null;
  const schedule = () => {
    if (frameId) {
      cancelAnimationFrame(frameId);
    }
    frameId = requestAnimationFrame(applyResponsiveTableLabels);
  };

  schedule();

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

startResponsiveTableObserver();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
